module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-arrows-light-blue-d898248f2ef43376ad101a846fed60e1.svg";